import { ReactComponent as LogoEvino } from '../../assets/images/logo_evino.svg'
import './style.css'

const ResultOptionCard = ({ option, onClick }) => {
  return (
    <a
      href={option.url}
      target='_blank'
      rel='noopener noreferrer'
      alt={`Comprar ${option.name}`}
      onClick={() => onClick?.(option)}
      className="inline-block h-full"
    >
      <div className="flex flex-col h-full items-center app-result">
        <img src={option.cover} alt={option.title} className="object-contain inline-block relative z-10 bg-transparent app-result-image" />

        <div className="flex flex-col justify-between h-full px-3 w-full rounded-2xl bg-white -mt-40 pt-40 app-result-info">
          <div>
            <div className="mt-5 mb-3 flex justify-center">
              <LogoEvino alt="Logo da Evino" className="object-contain h-5" fill="#E4303E" />
            </div>

            <h1 className="mb-4 font-bold leading-4">{option.title}</h1>
          </div>

          <div>
            {option.discount && <span className="font-bold mb-4 text-base uppercase text-white bg-red-950 px-3 rounded-sm inline-block">{option.discount}% off</span>}

            {option.salePrice && <span className="mb-px text-coolGray-375 block">R$ <s>{option.price}</s></span>}

            <span className="font-bold text-xl block mb-3 leading-6">R$ {option.salePrice || option.price}</span>
          </div>
        </div>
      </div>
    </a>
  )
}

export default ResultOptionCard
